<template>
  <div>
    <Nav></Nav>

    <h1 class="mb-4">Platform Menu Management</h1>
    <div class="mb-4">
      Selecciona alguna de las opciones en los paneles superiores para administrar tu menú:
      <ul>
        <li>Menus: Visión general de menus disponibles para las plataformas.</li>
        <li>Categorías: Categorías disponibles dentro de cada menú.</li>
        <li>Artículos: Los productos o items que aparecen en las categorías.</li>
        <li>Grupos de Modificadores: Modificadores que se pueden seleccionar para cada artículo.</li>
      </ul>
    </div>
    <b-row class="mt-4">
      <b-col md="6">
        <b-card title="Guía Rápida" class="mb-3">
          <p>Para configurar un menú para plataformas externas:</p>
          <ol>
            <li>Crea un menú con un nombre descriptivo</li>
            <li>Agrega categorías al menú</li>
            <li>Agrega artículos a las categorías</li>
            <li>Configura grupos de modificadores y asócialos a los artículos</li>
            <li>Asigna el menú a las tiendas en plataformas</li>
          </ol>
        </b-card>
      </b-col>
      <b-col md="6">
        <b-card title="Estadísticas" class="mb-3">
          <p v-if="menuStats.loading">Cargando estadísticas...</p>
          <div v-else>
            <p><strong>Menus activos:</strong> {{ menuStats.activeMenus }}</p>
            <p><strong>Categorías totales:</strong> {{ menuStats.totalCategories }}</p>
            <p><strong>Artículos totales:</strong> {{ menuStats.totalItems }}</p>
            <p><strong>Grupos de modificadores:</strong> {{ menuStats.totalModifierGroups }}</p>
          </div>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import axios from "axios";
import Nav from "../Nav.vue";

export default {
  name: "PlatformOverview",
  components: { Nav },
  data() {
    return {
      menuStats: {
        loading: true,
        activeMenus: 0,
        totalCategories: 0,
        totalItems: 0,
        totalModifierGroups: 0
      }
    };
  },
  mounted() {
    this.fetchMenuStats();
  },
  methods: {
    async fetchMenuStats() {
      try {
        const menusResponse = await axios.get("/platform/menus");
        const menus = menusResponse.data || [];
        
        this.menuStats.activeMenus = menus.filter(menu => menu.is_active).length;
        this.menuStats.totalCategories = 0;
        this.menuStats.totalItems = 0;
        this.menuStats.totalModifierGroups = 0;
        
        // This would be better done with a dedicated API endpoint that returns stats directly
        // For now, simulate fetching the counts from multiple endpoints
        for (const menu of menus) {
          try {
            const categoriesResponse = await axios.get(`/platform/menu/${menu.id}/categories`);
            const categories = categoriesResponse.data || [];
            this.menuStats.totalCategories += categories.length;
            
            const itemsResponse = await axios.get(`/platform/menu/${menu.id}/items`);
            const items = itemsResponse.data || [];
            this.menuStats.totalItems += items.length;
            
            const modifierGroupsResponse = await axios.get(`/platform/menu/${menu.id}/modifiergroups`);
            const modifierGroups = modifierGroupsResponse.data || [];
            this.menuStats.totalModifierGroups += modifierGroups.length;
          } catch (error) {
            console.error(`Error fetching details for menu ${menu.id}:`, error);
          }
        }
      } catch (error) {
        console.error("Error fetching menu statistics:", error);
      } finally {
        this.menuStats.loading = false;
      }
    },
    makeToast(title, content, variant) {
      this.$bvToast.toast(content, {
        title,
        variant,
        autoHideDelay: 5000,
        appendToast: true,
      });
    }
  }
};
</script>
